
import {HttpService} from '.'

export class ApiHttpService{

    getHeaders(){
        var headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");
        return headers
    }

    static async loadCourseHistories(){
        var service = new HttpService();
        var response = await service.get(`api/coursehistory`,null);
        return response;
    }

    static async loadCourseHistory(id){
        var service = new HttpService();
        var response = await service.get(`api/coursehistory/${id}`,null);
        return response;
    }

    /** Rebuild server-side public JSON cache for this course history (admin). */
    static async refreshCourseHistoryPublicCache(id){
        var service = new HttpService();
        var response = await service.post(`api/coursehistory/${id}/refresh-public-cache/`, {});
        return response;
    }

    static async saveCourseHistory(body){
        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/coursehistory/${body.id}`,body);
        }
        else
             response = await service.post('api/coursehistory/',body);
        return response;
    }

    static async loadCourseHistoryTalents(coursehistory,topten=0){
        var service = new HttpService();
        var response = await service.get(`api/coursehistorytalent/?coursehistory=${coursehistory}&topten=${topten}`,null);
        return response;
    }

    static async loadCourseHistoryFinalTalents(coursehistory){
        var service = new HttpService();
        var response = await service.get(`api/coursehistorytalent/?coursehistory=${coursehistory}&final=1`,null);
        return response;
    }

    static async loadCourseHistoryChampions(coursehistory){
        var service = new HttpService();
        var response = await service.get(`api/coursehistorytalent/?coursehistory=${coursehistory}&champion=1`,null);
        return response;
    }

    static async loadCourseSummary(course){
        var service = new HttpService();
        var response = await service.get(`api/course/${course}/summary`,null);
        return response;
    }

    static async saveCourseHistoryTalent(body){
        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/coursehistorytalent/${body.id}`,body);
        }
        else
             response = await service.post('api/coursehistorytalent/',body);
        return response;
    }

    static async loadCourseHistoryReferees(coursehistory,topten=0){
        var service = new HttpService();
        var response = await service.get(`api/coursehistoryreferee/?coursehistory=${coursehistory}&topten=${topten}`,null);
        return response;
    }

    static async saveCourseHistoryReferee(body){
        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/coursehistoryreferee/${body.id}`,body);
        }
        else
             response = await service.post('api/coursehistoryreferee/',body);
        return response;
    }


    
    static async saveSortOrder(url,ids) {
        let body = {
            ids: ids,
        };
        
        var service = new HttpService();
        var response;

        response = await service.post(url,body);
        return response;
    }

    static async loadCourseHistoryGalleries(coursehistory){
        var service = new HttpService();
        var response = await service.get(`api/coursehistorygallery/?coursehistory=${coursehistory}`,null);
        return response;
    }

    static async saveCourseHistoryGallery(id,coursehistory,url,episode){
        var service = new HttpService();
        var response;

        let body = {
            id: id,
            coursehistory: coursehistory,
            url: url,
            episode: episode,
        };

        if(body.id){
             response = await service.put(`api/coursehistorygallery/${body.id}`,body);
        }
        else
             response = await service.post('api/coursehistorygallery/',body);
        return response;
    }


    static async loadCoursesForAdmin(){
        var service = new HttpService();
        var response = await service.get(`api/courses/`,null);
        return response;
    }

    ////////////////////////////////////////////////////////

    static async loadPolls(){
        var service = new HttpService();
        var response = await service.get(`api/poll`,null);
        return response;
    }

    static async loadPoll(id){
        var service = new HttpService();
        var response = await service.get(`api/poll/${id}`,null);
        return response;
    }

    static async savePoll(body){
        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/poll/${body.id}`,body);
        }
        else
             response = await service.post('api/poll/',body);
        return response;
    }

    static async savePollItem(body){
        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/pollitem/${body.id}`,body);
        }
        else
             response = await service.post('api/pollitem/',body);
        return response;
    }

    static async loadPollItems(poll){
        var service = new HttpService();
        var response = await service.get(`api/pollitem/?poll=${poll}`,null);
        return response;
    }

    static async loadPollResults(poll){
        var service = new HttpService();
        var response = await service.get(`api/poll/report/?poll=${poll}`,null);
        return response;
    }

    ////////////////////////////////////////////////////////


    static async loadUserGalleries(userId, courseId){
        var query = `?size=200`;
        if(userId){
            query += `&user=${userId}`
        }
        if(courseId != null && courseId !== '' && courseId !== 0){
            query += `&course=${courseId}`
        }
        var service = new HttpService();
        var response = await service.get(`api/usergallery/${query}`,null);
        return response;
    }

    static async loadUserGalleryCategories(){
        var query = `?size=100`;
       
        var service = new HttpService();
        var response = await service.get(`api/usergallery/category/${query}`,null);
        return response;
    }

    static async saveUserGallery(user, url, title, category, course, id){

        let body = {
            "user": user,
            "url": url,
            "title": title,
            "category": category,
        }
        if (course != null && course !== '' && course !== 0) {
            body.course = course;
        }
        if (id != null && id !== '') {
            body.id = id;
        }

        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/usergallery/${body.id}`,body);
        }
        else
             response = await service.post('api/usergallery/',body);
        return response;
    }

    static async saveUserGalleryFeatured(id,is_featured){

        let body = {
            "id": id,
            "is_featured" : is_featured
        }

        var service = new HttpService();
        var response;
        
        response = await service.put(`api/usergallery/${body.id}`,body);
        return response;
    }

    
    static async saveUserGalleryCategory(body){
        var service = new HttpService();
        var response;

        if(body.id){
             response = await service.put(`api/usergallery/category/${body.id}`,body);
        }
        else
             response = await service.post('api/usergallery/category/',body);
        return response;
    }

    
}